module.exports = __webpack_public_path__ + "static/img/cx.aa81bb9e.svg";